export default __webpack_public_path__ + "static/media/menu.ee212561.svg";